/** Minimal typed event emitter. Listener errors are logged, never thrown to the emitter. */
export class Emitter<Events extends object> {
  private listeners = new Map<keyof Events, Set<(data: never) => void>>();

  on<K extends keyof Events>(evt: K, fn: (data: Events[K]) => void): () => void {
    let set = this.listeners.get(evt);
    if (!set) {
      set = new Set();
      this.listeners.set(evt, set);
    }
    set.add(fn as (data: never) => void);
    return () => {
      set.delete(fn as (data: never) => void);
    };
  }

  emit<K extends keyof Events>(evt: K, data: Events[K]): void {
    const set = this.listeners.get(evt);
    if (!set) return;
    for (const fn of Array.from(set)) {
      try {
        (fn as (data: Events[K]) => void)(data);
      } catch (e) {
        console.error(e);
      }
    }
  }

  count(evt: keyof Events): number {
    return this.listeners.get(evt)?.size ?? 0;
  }
}
